<template>
        <router-link :to="getLinkName"><feather-icon icon="Link2Icon" size="22" /> {{ name }} </router-link>
</template>

<script>

    export default {
        props: {
            name: {
                type: String,
                required:true
            },
            route:{
                type: Object,
                default: {},
                required:true
            }
        },
        computed: {
            getLinkName() {
                if(this.route){
                    return this.route;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>